import { render, staticRenderFns } from "./RegionTextSettingsForm.vue?vue&type=template&id=05449658&"
import script from "./RegionTextSettingsForm.vue?vue&type=script&lang=js&"
export * from "./RegionTextSettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports